import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './page/login';
import HealthBook from './page/healthbook';
import Template from './page/template';
import HealthRecordsHistory from './page/HealthRecordsHistory';
import ExamineeGroup from './page/ExamineeGroup';
import Campaign from './page/Campaign';
import UserManagement from './page/UserManagement';

// Global styles
const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Prompt', sans-serif;
  }
  
  html, body {
    font-family: 'Prompt', sans-serif;
    margin: 0;
    padding: 0;
    height: 100%;
    min-width: 1200px;
  }
  
  #root {
    height: 100vh;
    min-width: 1200px;
  }
`;

const AppContainer = styled.div`
  font-family: 'Prompt', sans-serif;
  min-height: 100vh;
`;

const App = () => {
  return (
    <Router>
      <GlobalStyle />
      <AppContainer>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/health-groups" element={<ExamineeGroup />} />
          <Route path="/campaigns" element={<Campaign />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/healthbook" element={<HealthBook />} />
          <Route path="/template" element={<Template />} />
          <Route path="/health-records-history" element={<HealthRecordsHistory />} />
        </Routes>
      </AppContainer>
    </Router>
  );
};

export default App;